import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { m } from '@/paraglide/messages.js';
import { signOut } from '@wundo/client/auth.ts';
import { forgetAppTheme } from '@wundo/client/appTheme.ts';

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});

export function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    /*
     * Land on /login either way. A failed sign-out still means the user asked
     * to leave, and the guard on / will send them back here if the session
     * turned out to survive.
     */
    void signOut().finally(() => {
      forgetAppTheme();
      void navigate({
        to: '/login',
        search: { redirect: undefined, error: undefined },
        replace: true,
      });
    });
  }, [navigate]);

  return (
    <main className='flex h-dvh items-center justify-center'>
      <p className='text-md text-ink-muted'>{m.logout_signing_out()}</p>
    </main>
  );
}
